import LegalLayout from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="April 21, 2026">
      <p>
        H&amp;E Associates LLC ("we", "us", "LegacyGrowth Engine") respects your
        privacy. This policy explains what information we collect when you use
        our website and SaaS application, how we use it, and the choices you
        have. By using LegacyGrowth Engine you agree to this policy.
      </p>

      <h2>1. Information we collect</h2>
      <ul>
        <li><strong>Account data</strong> — name, email, agency name, role, license details you provide during signup or onboarding.</li>
        <li><strong>Lead and referral data</strong> — names, contact info, care needs, and notes that you or your website visitors submit through our intake tools.</li>
        <li><strong>Usage data</strong> — pages visited, features used, IP address, browser, device, and timestamps. Used to keep the service secure and improve it.</li>
        <li><strong>Cookies</strong> — first-party cookies for authentication and preferences. We do not use third-party advertising cookies.</li>
      </ul>

      <h2>2. How we use information</h2>
      <ul>
        <li>Provide, secure, and improve the service.</li>
        <li>Send transactional email (sign-in confirmations, alerts, billing receipts).</li>
        <li>Comply with legal obligations and enforce our Terms of Service.</li>
        <li>With your explicit opt-in, send product updates. You can opt out at any time.</li>
      </ul>
      <p>We do not sell personal information.</p>

      <h2>3. Protected Health Information (PHI)</h2>
      <p>
        When your agency uses LegacyGrowth Engine to capture or store PHI, we
        act as your Business Associate under HIPAA. Our handling of PHI is
        governed by the Business Associate Agreement (BAA) you sign during
        onboarding. See our <a href="/hipaa">HIPAA Notice</a> for details.
      </p>

      <h2>4. Sharing</h2>
      <p>We share information only with:</p>
      <ul>
        <li>Sub-processors that help us run the service (cloud hosting, email delivery, SMS, error monitoring) — each under written confidentiality and, where applicable, BAAs.</li>
        <li>Authorities, when legally required and after challenging overbroad requests where lawful.</li>
        <li>An acquirer in the event of a merger, acquisition, or asset sale; we will notify you before your data becomes subject to a different privacy policy.</li>
      </ul>

      <h2>5. Data retention</h2>
      <p>
        Account data is retained for the life of your account plus 30 days
        after cancellation, after which it is deleted or de-identified. Signed
        BAA documents are retained for 6 years to satisfy HIPAA record-keeping
        requirements.
      </p>

      <h2>6. Your choices</h2>
      <ul>
        <li>Access, correct, or export your data from your account settings.</li>
        <li>Request deletion by emailing <a href="mailto:privacy@legacygrowthengine.com">privacy@legacygrowthengine.com</a>.</li>
        <li>California (CCPA/CPRA), Virginia (VCDPA), and other US-state residents have additional rights including the right to know, delete, and opt out of sale (we do not sell data).</li>
      </ul>

      <h2>7. Security</h2>
      <p>
        Data is encrypted in transit (TLS 1.2+) and at rest. Access is gated by
        role-based permissions and row-level security at the database tier.
        Production access is limited and audited. No system is perfectly secure;
        we will notify affected users of any breach as required by law.
      </p>

      <h2>8. International users</h2>
      <p>
        LegacyGrowth Engine is operated from the United States. If you access
        the service from outside the US, you consent to the transfer of your
        information to the US for processing.
      </p>

      <h2>9. Children</h2>
      <p>
        The service is not directed to children under 13 and we do not
        knowingly collect personal information from them.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update this policy from time to time. Material changes will be
        announced in-app or by email at least 14 days before they take effect.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions? Email <a href="mailto:privacy@legacygrowthengine.com">privacy@legacygrowthengine.com</a>{" "}
        or write to H&amp;E Associates LLC, Privacy Office.
      </p>
    </LegalLayout>
  );
}